import * as api from "../athleteCommon/API";
import Swal from "sweetalert2";
import Utils from "./Utils";

// User - Menus
export function UserMenus() {
    const userMenus = api.GetUserMenus;
    return fetch(userMenus, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message);
                return null;
            }
        })
}

// Get Metrics
export function getMertricsData(mnth: string) {
    const metrics = api.AthleteMetricsData;
    const formData = new FormData();
    formData.append('months', mnth);
    return fetch(metrics, {
        method: "POST",
        headers: {
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        },
        body: formData
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// Get Metricscale
export function getMertricScale() {
    const metrics = api.MetricScale;
    return fetch(metrics, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// Athlete Profile
export function athleteProfile() {
    const profile = api.AthleteProfile;
    return fetch(profile, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message);
                return null;
            }
        })
}


//  list, get injury
export function injury(rowid: string | null) {
    let inj = api.Injury;
    if (rowid) {
        inj += "/" + rowid;
    }
    return fetch(inj, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get injury Assessment
export function injuryAssessment(rowid: string | null) {
    let inj = api.InjuryAssessment;
    if (rowid) {
        inj += "/" + rowid;
    }
    return fetch(inj, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get injury diagnosis
export function injuryDiagnosis(rowid: string | null) {
    let inj = api.InjuryDiagnosis;
    if (rowid) {
        inj += "/" + rowid;
    }
    return fetch(inj, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get injury treatment
export function injuryTreatment(rowid: string | null) {
    let treat = api.InjuryTreatment;
    if (rowid) {
        treat += "/" + rowid;
    }
    return fetch(treat, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get blood group
export function bloodGroup(rowid: string | null) {
    let bldGrp = api.BloodGroup;
    if (rowid) {
        bldGrp += "/" + rowid;
    }
    return fetch(bldGrp, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get allergy type
export function allergyType(rowid: string | null) {
    let alrgyTyp = api.AllergyType;
    if (rowid) {
        alrgyTyp += "/" + rowid;
    }
    return fetch(alrgyTyp, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get medication category
export function medicationCategory(rowid: string | null) {
    let medCtgry = api.MedicationCtgry;
    if (rowid) {
        medCtgry += "/" + rowid;
    }
    return fetch(medCtgry, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get alcohol
export function alcohol(rowid: string | null) {
    let alcohol = api.Alcohol;
    if (rowid) {
        alcohol += "/" + rowid;
    }
    return fetch(alcohol, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get tobacco
export function tobacco(rowid: string | null) {
    let tbco = api.Tobacco;
    if (rowid) {
        tbco += "/" + rowid;
    }
    return fetch(tbco, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get injury type
export function injuryType(rowid: string | null) {
    let inj = api.InjuryType;
    if (rowid) {
        inj += "/" + rowid;
    }
    return fetch(inj, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get region affected
export function regionAffected(rowid: string | null) {
    let rgn = api.RegionAffected;
    if (rowid) {
        rgn += "/" + rowid;
    }
    return fetch(rgn, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get diagnosis type
export function diagnosisType(rowid: string | null) {
    let diag = api.DiagnosisType;
    if (rowid) {
        diag += "/" + rowid;
    }
    return fetch(diag, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get injury severity
export function injurySeverity(rowid: string | null) {
    let inj = api.InjurySeverity;
    if (rowid) {
        inj += "/" + rowid;
    }
    return fetch(inj, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get injury mechanism
export function injuryMechanism(rowid: string | null) {
    let inj = api.InjuryMechanism;
    if (rowid) {
        inj += "/" + rowid;
    }
    return fetch(inj, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get injury management
export function injuryManagement(rowid: string | null) {
    let inj = api.InjuryManagement;
    if (rowid) {
        inj += "/" + rowid;
    }
    return fetch(inj, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get time lost
export function timeLost(rowid: string | null) {
    let time = api.TimeLost;
    if (rowid) {
        time += "/" + rowid;
    }
    return fetch(time, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get surgery category
export function surgeryCategory(rowid: string | null) {
    let surg = api.SurgeryCategory;
    if (rowid) {
        surg += "/" + rowid;
    }
    return fetch(surg, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get body region
export function bodyRegion(rowid: string | null) {
    let bdy = api.BodyRegion;
    if (rowid) {
        bdy += "/" + rowid;
    }
    return fetch(bdy, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get rehabilitation duration
export function rehabilitationDuration(rowid: string | null) {
    let rehab = api.RehabilitationDuration;
    if (rowid) {
        rehab += "/" + rowid;
    }
    return fetch(rehab, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get physiological type
export function physiologicalType(rowid: string | null) {
    let physio = api.PhysiologicalType;
    if (rowid) {
        physio += "/" + rowid;
    }
    return fetch(physio, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list talent scouting
export function listTalentScouting() {
    const listTlntSctng = api.ListTalentScouting;
    return fetch(listTlntSctng, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list Batches
export function listBatches() {
    const listBtches = api.ListBatches;
    return fetch(listBtches, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list Batch Athlete
export function listBatchAthlete() {
    const listBtchesAthlete = api.ListBatchesAthletes;
    return fetch(listBtchesAthlete, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list Schedules
export function listSchedules() {
    const listScdls = api.ListSchedules;
    return fetch(listScdls, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list Assessment
export function listAssessments() {
    const listAsmnts = api.ListAssessments;
    return fetch(listAsmnts, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function centerBatch(rowid: string | null) {
    let getcntrBtch = api.CenterBatch;
    if (rowid) {
        getcntrBtch += "/" + rowid;
    }
    return fetch(getcntrBtch, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function centerBatchAthelete(rowid: string | null) {
    let getbtchAthlt = api.CenterBatchAthlete;
    if (rowid) {
        getbtchAthlt += "/" + rowid;
    }
    return fetch(getbtchAthlt, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get center schedule
export function centerSchedule(rowid: string | null) {
    let scdl = api.CenterSchedule;
    if (rowid) {
        scdl += "/" + rowid;
    }
    return fetch(scdl, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get center attendance
export function centerAttendance(rowid: string | null) {
    let atndc = api.CenterAttendance;
    if (rowid) {
        atndc += "/" + rowid;
    }
    return fetch(atndc, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get center assessment
export function centerAssessment(rowid: string | null) {
    let asmnt = api.CenterAssessment;
    if (rowid) {
        asmnt += "/" + rowid;
    }
    return fetch(asmnt, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get hpc batch
export function hpcBatch(rowid: string | null) {
    let btch = api.HPCBatch;
    if (rowid) {
        btch += "/" + rowid;
    }
    return fetch(btch, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function hpcBatchAthelete(rowid: string | null) {
    let btchAthlt = api.HPCBatchAthlete;
    if (rowid) {
        btchAthlt += "/" + rowid;
    }
    return fetch(btchAthlt, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get hpc schedule
export function hpcSchedule(rowid: string | null) {
    let scdl = api.HPCSchedules;
    if (rowid) {
        scdl += "/" + rowid;
    }
    return fetch(scdl, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get hpc attendance
export function hpcAttendance(rowid: string | null) {
    let atndc = api.HPCAttendance;
    if (rowid) {
        atndc += "/" + rowid;
    }
    return fetch(atndc, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get hpc assessment
export function hpcAssessment(rowid: string | null) {
    let asmnt = api.HPCAssessment;
    if (rowid) {
        asmnt += "/" + rowid;
    }
    return fetch(asmnt, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function competitionPerformance(rowid: string | null) {
    let getCompPrfmnc = api.competitionPerformance;
    if (rowid) {
        getCompPrfmnc += "/" + rowid;
    }
    return fetch(getCompPrfmnc, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function externalCompetitions(rowid: string | null) {
    let getEvent = api.ExternalCompetitionEvents;
    if (rowid) {
        getEvent += "/" + rowid;
    }
    return fetch(getEvent, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function externalCompAthltEntry(rowid: string | null) {
    let getPrfmnc = api.ExternalCompetitionAthleteEntry;
    if (rowid) {
        getPrfmnc += "/" + rowid;
    }
    return fetch(getPrfmnc, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function externalCompAthleteAttempts(rowid: string | null) {
    let getAttempts = api.ExternalCompetitionAttempts;
    if (rowid) {
        getAttempts += "/" + rowid;
    }
    return fetch(getAttempts, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function externalPerformance(rowid: string | null) {
    let getPrfmnc = api.ExternalCompetitionResults;
    if (rowid) {
        getPrfmnc += "/" + rowid;
    }
    return fetch(getPrfmnc, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function worldRecord(rowid: string | null) {
    let getrecord = api.WorldRecord;
    if (rowid) {
        getrecord += "/" + rowid;
    }
    return fetch(getrecord, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function externalCompAthletes(rowid: string | null) {
    let getLevels = api.ExternalCompetitionAthletes;
    if (rowid) {
        getLevels += "/" + rowid;
    }
    return fetch(getLevels, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function externalCompSinclairConts(rowid: string | null) {
    let getConst = api.ExternalCompetitionSinclairConstants;
    if (rowid) {
        getConst += "/" + rowid;
    }
    return fetch(getConst, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function getAthletesByWeight(rowid: string | null) {
    let getAthlt = api.ListAthletesByWeight;
    if (rowid) {
        getAthlt += "/" + rowid;
    }
    return fetch(getAthlt, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}
